const origins = {
  list: {
    title: 'Origens',
    description: 'Gerencie as origens de clientes do sistema.',
    mobileDescription: 'Gerencie as origens de clientes.',
    totalLabel: 'origem(ns)',
    create: 'Nova Origem',
    searchPlaceholder: 'Buscar por nome...',
    emptySearchTitle: 'Nenhum resultado encontrado',
    emptyInitialTitle: 'Nenhuma origem cadastrada',
    emptySearchDescription:
      'Nenhuma origem corresponde aos critérios de busca. Tente ajustar os filtros.',
    emptyInitialDescription: 'Comece cadastrando a primeira origem de cliente.',
    mobileEmptyMessage: 'Nenhuma origem encontrada.',
    notesAriaLabel: 'Ver observação',
  },
  filters: {
    status: 'Status',
    active: 'Ativa',
    inactive: 'Inativa',
  },
  table: {
    name: 'Nome',
    companies: 'Empresas',
    status: 'Status',
    actions: 'Ações',
  },
  form: {
    createTitle: 'Nova Origem',
    editTitle: 'Editar Origem',
    createDescription: 'Preencha os dados para cadastrar uma nova origem de clientes.',
    editDescription: 'Atualize as informações da origem de clientes.',
    loading: 'Carregando informações...',
    loadError: 'Não foi possível carregar os dados da origem.',
    retry: 'Tentar novamente',
    nameLabel: 'Nome',
    notesLabel: 'Observações',
    cancel: 'Cancelar',
    createSubmit: 'Cadastrar origem',
    editSubmit: 'Salvar alterações',
    creating: 'Cadastrando...',
    saving: 'Salvando...',
  },
  actions: {
    activate: 'Reativar',
    inactivate: 'Inativar',
    inactivateTitle: 'Inativar origem',
    inactivateDescription:
      'Tem certeza que deseja inativar a origem "{{name}}"? Ela não aparecerá mais como opção ao cadastrar empresas.',
    inactivating: 'Inativando...',
    activateTitle: 'Reativar origem',
    activateDescription:
      'Tem certeza que deseja reativar a origem "{{name}}"? Ela voltará a aparecer como opção ao cadastrar empresas.',
    activating: 'Reativando...',
  },
  toast: {
    createSuccess: 'Origem cadastrada com sucesso',
    createError: 'Ocorreu um erro ao cadastrar a origem',
    updateSuccess: 'Origem atualizada com sucesso',
    updateError: 'Ocorreu um erro ao atualizar a origem',
    inactivateSuccess: 'Origem inativada com sucesso',
    inactivateError: 'Ocorreu um erro ao inativar a origem',
    activateSuccess: 'Origem reativada com sucesso',
    activateError: 'Ocorreu um erro ao reativar a origem',
  },
}

export default origins
